<template>
    <teleport to="head">
        <component
            :is="'script'"
            src="https://smtpjs.com/v3/smtp.js"
            async
        />
    </teleport>
    <!-- Contact section start -->
	<section id="contact-section" class="px-12 lg:px-32 py-16 relative">
        <!-- Main text start -->
		<h1 class="uppercase text-5xl mb-4 font-semibold ">
			<strong>{{ $t('contact.contactSection') }}</strong>
		</h1>
		<!-- Main text end -->

        <!-- Form start -->
        <div class="grid grid-cols-1 md:grid-cols-2 w-full">
            <div class="hidden md:flex justify-center items-center">
                <img src="@/assets/shake-hands.jpeg" alt="shake-hands" class="w-96 h-96 object-cover rounded-full">
            </div>
            <div class="flex flex-col w-full items-center">
                <label for="user_email" class="text-stone-500 text-left">{{ $t('contact.emailAddress') }}</label>
                <input v-model="mailRecipient" type="email" name="user_email" id="user_email" class="bg-stone-200 py-2 px-4 w-full mb-6 xl:w-1/2" :placeholder="$t('contact.mailPlaceHolder')" required>

                <label for="user_message" class="text-stone-500 text-left">{{ $t('contact.message') }}</label>
                <textarea v-model="mailMessage" name="user_message" id="user_message" cols="30" rows="10" class="bg-stone-200 py-2 px-4 w-full mb-6 xl:w-1/2" :placeholder="$t('contact.message')" required></textarea>

                <label for="mail_subject" class="text-stone-500 text-left">{{ $t('contact.subject') }}</label>
                <input v-model="mailSubject" type="text" name="mail_subject" id="mail_subject" class="bg-stone-200 py-2 px-4 w-full mb-6 xl:w-1/2" :placeholder="$t('contact.subject')" required>

                <button @click.prevent="sendEmail" class="btn custom-btn w-full md:w-1/2">{{ $t('contact.send') }}</button>
            </div>
        </div>
        <!-- Form end -->

        <!-- Circle start -->
        <div class="bg-[#132e63] h-44 w-44 md:h-52 md:w-52 rounded-full absolute -top-20 left-0 mt-16 -z-20 opacity-20"></div>
        <!-- Circle end -->
	</section>
	<!-- Contact section end -->
</template>
<script>
// import sendMail from '@/services/mailService';
import { Email } from '@/services/smtp.js';

export default {
    data() {
        return {
            // mailRecipient: '',
            // mailSubject: '',
            // mailMessage: '',
            name: '',
            email: '',
            message: '',
            subject: '',
        }
    },
    methods: {
        sendEmail() {
            Email.send({
                SecureToken: "",
                To: "smtp.gmail.com",
                From: "",
                name: this.name,
                Subject: this.subject,
                Body: this.message,
            }).then((message) => alert(message));
        }
    }
}
</script>

<style scoped>
.custom-btn {
    background-color: #132e63 !important;
    color: #f5f5f5;
}
</style>